/* eslint-disable */

import React from 'react'
import { Link } from 'react-router-dom'

// config
import l from '../../config/localization'

// utils
import stringUtils from '../../utils/string'

import { CheckCircle, XCircle } from 'components/Icons/Icons'

// Load components synchronously
import SingleCard from 'components/SingleCard/SingleCard'

import {
  CardContent,
  CardLinkWrapper,
  ExpiryNotice,
  IconWrapper,
  OpportunityDescription,
  Title,
  UserJoinedIcon,
  UserJoinedLabel
} from './styles'
import constants from '../../config/constants'

class PublicEventCard extends React.Component {
  displayUserJoinedInfo({ userApplication }) {
    if (!userApplication) return null

    const didWithdraw =
      userApplication.status === constants.APPLICATION_STATUS_NAMES.MARKED_AS_NON_ATTENDED

    if (didWithdraw) {
      return (
        <UserJoinedIcon withdrew>
          <XCircle withdrew />
          <UserJoinedLabel>Withdrew</UserJoinedLabel>
        </UserJoinedIcon>
      )
    }

    return (
      <UserJoinedIcon>
        <CheckCircle />
        <UserJoinedLabel>Joined</UserJoinedLabel>
      </UserJoinedIcon>
    )
  }

  render() {
    const {
      id,
      title,
      description,
      gs_has_expired,
      is_expired,
      short_url: shortUrl,
      pvt_share_key: pvtShareKey
    } = this.props

    const { splicedString } = stringUtils.trimText({ string: description, wordLimit: 40 })
    const oppUrl = pvtShareKey
      ? `/${l('ROUTE_OPPS')}/${id}?title=${shortUrl}&pvtShareKey=${pvtShareKey}`
      : `/${l('ROUTE_OPPS')}/${id}?title=${shortUrl}`

    const isExpired = gs_has_expired || is_expired

    const startDate = this.props.human_readable_start_date

    return (
      <Link to={oppUrl}>
        <SingleCard fullHeight hoverShadow>
          <ExpiryNotice expired={isExpired}></ExpiryNotice>

          <CardLinkWrapper expired={isExpired}>
            <CardContent>
              <Title>{title}</Title>
              <OpportunityDescription description={splicedString} />

              <IconWrapper infoType={'Date'} value={startDate} />
            </CardContent>
          </CardLinkWrapper>
        </SingleCard>
      </Link>
    )
  }
}

export default PublicEventCard
